import VioletAlertBadge from 'assets/icons/alert-badge-violet.png'
import { ModalActionTypes } from 'utils/prompts'

export const unverifiedUserPrompts = new Map([
  [
    'verificationRequired',
    {
      image: {
        src: VioletAlertBadge,
        alt: '',
      },
      message: 'Before you can continue, we just need to verify a few details about you.',
      actions: [
        {
          label: 'Cancel',
          type: ModalActionTypes.secondary,
        },
        {
          label: 'Verify now',
          type: ModalActionTypes.primary,
        },
      ],
      title: 'Verification required',
    },
  ],
  [
    'pendingApproval',
    {
      image: {
        src: VioletAlertBadge,
        alt: '',
      },
      button: 'OK',
      message:
        'We are currently verifying your information. This may take up to 2 business days to complete.',
      title: 'Your account verification is processing',
    },
  ],
])
